export default "brands";
